import { __makeTemplateObject } from "tslib";
import React from 'react';
import { css, cx } from 'emotion';
import { VizLegendSeriesIcon } from './VizLegendSeriesIcon';
import { VizLegendStatsList } from './VizLegendStatsList';
import { useStyles } from '../../themes';
/**
 * @internal
 */
export var VizLegendListItem = function (_a) {
    var item = _a.item, onSeriesColorChange = _a.onSeriesColorChange, onLabelClick = _a.onLabelClick;
    var styles = useStyles(getStyles);
    return (React.createElement("div", { className: styles.itemWrapper },
        React.createElement(VizLegendSeriesIcon, { disabled: !onSeriesColorChange, color: item.color, onColorChange: function (color) {
                if (onSeriesColorChange) {
                    onSeriesColorChange(item.label, color);
                }
            } }),
        React.createElement("div", { onClick: function (event) {
                if (onLabelClick) {
                    onLabelClick(item, event);
                }
            }, className: cx(styles.label, item.disabled && styles.labelDisabled) }, item.label),
        item.getDisplayValues && React.createElement(VizLegendStatsList, { stats: item.getDisplayValues() })));
};
VizLegendListItem.displayName = 'VizLegendListItem';
var getStyles = function (theme) { return ({
    label: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    label: LegendLabel;\n    cursor: pointer;\n    white-space: nowrap;\n  "], ["\n    label: LegendLabel;\n    cursor: pointer;\n    white-space: nowrap;\n  "]))),
    labelDisabled: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    label: LegendLabelDisabled;\n    color: ", ";\n  "], ["\n    label: LegendLabelDisabled;\n    color: ", ";\n  "])), theme.colors.linkDisabled),
    itemWrapper: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    white-space: nowrap;\n    align-items: center;\n    flex-grow: 1;\n  "], ["\n    display: flex;\n    white-space: nowrap;\n    align-items: center;\n    flex-grow: 1;\n  "]))),
    value: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    text-align: right;\n  "], ["\n    text-align: right;\n  "]))),
    yAxisLabel: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), theme.palette.gray2),
}); };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=VizLegendListItem.js.map